import React, { useState } from 'react';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // Credenciales (en producción deberían estar en un servidor)
  const CREDENTIALS = {
    username: 'artefacto',
    password: 'm3mbr4n42028'
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (username === CREDENTIALS.username && password === CREDENTIALS.password) {
      // Guardar en sessionStorage
      sessionStorage.setItem('isAuthenticated', 'true');
      onLogin(true);
    } else {
      setError('Usuario o contraseña incorrectos');
      setTimeout(() => setError(''), 3000);
    }
  };

  const styles = {
    container: {
      position: 'fixed',
      inset: 0,
      background: 'radial-gradient(circle at center, rgba(200, 180, 150, 0.02) 0%, #000000 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2000,
    },
    form: {
      background: 'rgba(10, 10, 10, 0.95)',
      padding: '40px',
      borderRadius: '12px',
      border: '1px solid rgba(200, 180, 150, 0.2)',
      backdropFilter: 'blur(20px)',
      width: '100%',
      maxWidth: '400px',
      boxShadow: '0 4px 24px rgba(0, 0, 0, 0.6)',
    },
    title: {
      fontSize: '24px',
      fontWeight: 100,
      letterSpacing: '0.3em',
      color: '#c8b496',
      textAlign: 'center',
      marginBottom: '8px',
    },
    subtitle: {
      fontSize: '12px',
      color: 'rgba(200, 180, 150, 0.5)',
      textAlign: 'center',
      marginBottom: '30px',
      letterSpacing: '0.2em',
      textTransform: 'uppercase',
    },
    inputGroup: {
      marginBottom: '20px',
    },
    label: {
      display: 'block',
      fontSize: '10px',
      color: 'rgba(200, 180, 150, 0.6)',
      marginBottom: '8px',
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
    },
    input: {
      width: '100%',
      padding: '12px',
      background: 'rgba(200, 180, 150, 0.05)',
      border: '1px solid rgba(200, 180, 150, 0.15)',
      borderRadius: '4px',
      color: '#c8b496',
      fontSize: '14px',
      fontFamily: 'inherit',
      outline: 'none',
      transition: 'all 0.2s ease',
    },
    button: {
      width: '100%',
      padding: '12px',
      background: 'linear-gradient(135deg, rgba(200, 180, 150, 0.2) 0%, rgba(200, 180, 150, 0.1) 100%)',
      border: '1px solid rgba(200, 180, 150, 0.3)',
      borderRadius: '6px',
      color: 'rgba(200, 180, 150, 0.9)',
      fontSize: '11px',
      fontWeight: 600,
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      fontFamily: 'inherit',
      marginTop: '10px',
    },
    error: {
      color: '#ff6b6b',
      fontSize: '12px',
      textAlign: 'center',
      marginTop: '15px',
      minHeight: '20px',
    }
  };

  return (
    <div style={styles.container}>
      <form style={styles.form} onSubmit={handleSubmit}>
        <h1 style={styles.title}>MEMBRANA Vol. 3</h1>
        <p style={styles.subtitle}>Acceso Restringido</p>
        
        <div style={styles.inputGroup}>
          <label style={styles.label}>Usuario</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={styles.input}
            placeholder="Ingrese usuario"
            required
            autoFocus
          />
        </div>
        
        <div style={styles.inputGroup}>
          <label style={styles.label}>Contraseña</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            placeholder="Ingrese contraseña"
            required
          />
        </div>
        
        <button 
          type="submit" 
          style={styles.button}
          onMouseEnter={(e) => {
            e.target.style.background = 'linear-gradient(135deg, rgba(200, 180, 150, 0.3) 0%, rgba(200, 180, 150, 0.2) 100%)';
            e.target.style.transform = 'translateY(-1px)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'linear-gradient(135deg, rgba(200, 180, 150, 0.2) 0%, rgba(200, 180, 150, 0.1) 100%)';
            e.target.style.transform = 'translateY(0)';
          }}
        >
          Acceder
        </button>
        
        <div style={styles.error}>{error}</div>
      </form>
    </div>
  );
};

export default Login;